import React from "react";

export default function SectionLabel({ children, className = "" }) {
  return (
    <div className={`text-[9px] uppercase tracking-[0.18em] text-neutral-500 font-semibold ${className}`}>
      {children}
    </div>
  );
}
